import React, { useEffect, useState, useCallback, useMemo } from 'react';
import ReactDOM from 'react-dom';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { Grid, Checkbox, FormGroup, FormControlLabel, Chip, Paper, FormControl, FormLabel, TextField, Button, Select, MenuItem, InputLabel } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, AppBar, Toolbar, Drawer, CssBaseline, Typography, Menu,Tabs,Tab } from '@mui/material';
import { makeStyles } from '@mui/styles';
import _, { omit, pick } from 'lodash'
import PF from "../_Services/publicFunction";
import { useSnackbar } from "notistack";
import Qs from "qs";
import NumberFormat from 'react-number-format';

import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';
import { F } from 'ramda';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import Minmax from './MinmaxMobile';
import { indigo, grey, blue, teal } from '@mui/material/colors';
import GetAppIcon from '@mui/icons-material/GetApp';
import FileDownloadOffIcon from '@mui/icons-material/FileDownloadOff';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled, useTheme } from '@mui/material/styles';
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import useSound from 'use-sound';
import switchlight from '../components/sounds/switchlight.wav';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../reducers/app";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useNavigate, Navigate } from 'react-router-dom';
import { isMobile, browserName } from 'react-device-detect';
import { saveAs } from "file-saver";
import { GTranslate } from '@mui/icons-material';
import moment from "moment";
import AnnualReportCustomer from './AnnualReportCustomer';

// const useStyles = makeStyles((theme) => ({
//     root: {
//         width: '100%',
//     },

//     half_background: {
//         background: "linear-gradient(to top, yellow 50%, transparent 50%)"
//     },
//     backdrop: {
//         zIndex: theme.zIndex.drawer + 1,
//         color: '#fff',
//     },
//     closeButton: {
//         position: 'absolute',
//         right: theme.spacing(1),
//         top: theme.spacing(1),
//         color: theme.palette.grey[500],
//     },
//     chip: {
//         margin: theme.spacing(0.5),
//     },
// }));

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBar2 = styled(AppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

const App = () => {
    const intl = useIntl();

    const { UserInfo, dark, token, i18n } = useSelector(state => ({
        UserInfo: state.app.UserInfo,
        dark: state.app.dark,
        token: state.app.token,
        i18n: state.app.i18n
    }));

    useEffect(() => {
        // console.log(UserInfo);

        // gridRef.current.api.sizeColumnsToFit();
        PF.instance({
            method: "post",
            url: PF.url2 + "/Minmax/GetIDList_Customer",        //Diff
            data: Qs.stringify({
                Action: "1",
                parameter: {
                    PersonalId: UserInfo.PersonalId

                }
            }),
            headers: { Authorization: 'Bearer ' + token }       //外部用戶登入，沒有localStorage
        })
            .then(function (response) {
                //  console.log(response.data)
                const { TotalRecord, rows3 } = response.data
                if (TotalRecord <= 0) {
                    // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                    enqueueSnackbar("查無資料", { variant: "error", style: { whiteSpace: 'pre-line' } });
                } else {
                    // enqueueSnackbar("Success", { variant: "success", style: { whiteSpace: 'pre-line' } });
                    // console.log(rows)
                    setPersonItem(rows3);
                }
            })


    }, [])
    const [url, seturl] = useState(null);
    // const classes = useStyles();
    const [QueryString, setQueryString] = React.useState('');
    const PicCategoryArray = ["超音波檢查", "數位斷層合成掃描", '胸部能量減影',
        , "一般X光"
        , "三連片"
        , "內視鏡"
        , "身體組成分析"
        , "心電圖"
        , "自律神經檢查"
        , "眼底攝影"];

    const CategoryArray05 = [
        { id2: "0501", title2: "超音波檢查" },
        { id2: "0502", title2: "數位斷層合成掃描" },
        { id2: "0503", title2: "胸部能量減影" },
        { id2: "0504", title2: "一般X光" },
        { id2: "0505", title2: "三連片" },
        { id2: "0506", title2: "內視鏡" },
        { id2: "0507", title2: "身體組成分析" },
        { id2: "0508", title2: "心電圖" },
        { id2: "0509", title2: "自律神經檢查" },
        { id2: "0510", title2: "眼底攝影" },
    ];

    const handleChange = event => {
        const { name, value } = event.target;
        setQueryString(value);
    }
    const { enqueueSnackbar } = useSnackbar();
    const gridRef = React.useRef();
    const reportLoadSeqRef = React.useRef(0);

    const [GaugeItem, setGaugeItem] = useState({})
    // const [LabItem, setLabItem] = useState({})

    const [PicObj, setPicObj] = useState({})
    const [Profile, setProfile] = useState({})
    const [Array02_1, setArray02_1] = useState([])
    const [Array02_2, setArray02_2] = useState([])
    const [Array02, setArray02] = useState([])
    const [Array03, setArray03] = useState([])
    const [Array04, setArray04] = useState([])
    const [Array06, setArray06] = useState([])
    const initialItems = [{ id: '01', title: ' - 基本資料', i18n: intl.formatMessage({ id: "基本資料" }) }, { id: '02', title: ' - 異常項目', i18n: intl.formatMessage({ id: "異常項目" }) }
        // { id: '04', title: '04 - 檢驗', data: Array04 },
        // { id: '05', title: '05 - 影像檢查', data: GaugeItem },
        // { id: '06', title: '06 - 其他檢查', data: Array06 },

    ]

    const [items, setitems] = useState(initialItems)
    const initialsubItems = {
        '03': [{ id2: '0301', title2: '一般體格', i18n2: intl.formatMessage({ id: "一般體格" }) }, { id2: '0302', title2: '醫生問診', i18n2: intl.formatMessage({ id: "醫生問診" }) }],
        '04': [],
        '05': [],
        '06': []
    }
    const [subItems, setsubItems] = useState(initialsubItems);
    const resetReportState = () => {
        setitems(initialItems);
        setArray02([]);
        setArray02_1([]);
        setArray02_2([]);
        setsubItems(initialsubItems);
        setProfile({});
        setPicObj({});
        setArray03([]);
        setArray04([]);
        setArray06([]);
        setGaugeItem({});
    }
    const onRowDoubleClicked = (event) => {
        const { data, column } = event;
        // console.log(data.barcode);
        if (column.colId !== 'checkdate') {
            getFullData(data.barcode)
            // handleQueryBarCodeStr(data.barcode);
            // setBarCodeStr(data.BarCodeStr);
            // handleClose();
            setOpen(true)
        }


    }
    const onFirstDataRendered = useCallback((params) => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);
    useEffect(() => {
        // // gridRef.current?.api?.redrawRows();
        // // gridRef.current?.api?.refreshCells();
        setColumnDefs(prev => {
            return prev.map(item => {
                if (item.field === 'UserName') {
                    return { ...item, cellStyle: { backgroundColor: dark ? blue[900] : blue[50] } }
                } else {
                    return item
                }
            })
        })

    }, [dark]);
    const initialColumnDefs = [   //非手機介面，則顯示較多
        { field: 'checkdate', headerName: intl.formatMessage({ id: "健檢日" }), width: 120, cellRenderer: 'agGroupCellRenderer' },
        // { field: 'barcode', headerName: "條碼號", width: 150 },
        // { field: 'customerName', headerName: intl.formatMessage({ id: "專案名稱" }), width: 250 },
        { field: 'UserName', headerName: intl.formatMessage({ id: "Name" }), width: 100, cellStyle: { backgroundColor: blue[50] } },
        { field: 'PersonalId', headerName: intl.formatMessage({ id: "ID." }), width: 150 },
        // { field: 'sogi', headerName: "手機", width: 150 },
        { field: 'sex', headerName: intl.formatMessage({ id: "Gender" }), width: 80 },
        // { field: 'Birthday', headerName: "生日", width: 120 },
    ];
    const initialColumnDefsMobile = [    //若是手機介面則顯示較少
        { field: 'checkdate',  headerName: intl.formatMessage({ id: "健檢日" }), width: 120, cellRenderer: 'agGroupCellRenderer' },
        // { field: 'barcode', headerName: "條碼號", width: 150 },
        // { field: 'customerName', headerName: "專案名稱", width: 250 },
        { field: 'UserName', headerName: intl.formatMessage({ id: "Name" }), width: 100, cellStyle: { backgroundColor: blue[50] } },
        // { field: 'PersonalId', headerName: "身分證號", width: 150 },
        // { field: 'sogi', headerName: "手機", width: 150 },
        { field: 'sex', headerName: intl.formatMessage({ id: "Gender" }), width: 80 },
        // { field: 'Birthday', headerName: "生日", width: 120 },

    ]
    const [columnDefs, setColumnDefs] = React.useState(isMobile ? initialColumnDefsMobile : initialColumnDefs)
    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
    };
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        reportLoadSeqRef.current += 1;
        setOpen(false);
        resetReportState();
    };
    const [PersonItem, setPersonItem] = React.useState([])

    const handleQuery = e => {
        if (QueryString !== "") {
            PF.instance({
                method: "post",
                url: PF.url2 + "/Minmax/GetIDList_Customer",
                data: Qs.stringify({
                    Action: "1",
                    parameter: {
                        PersonalId: QueryString
                    }
                }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    // console.log(response.data)
                    const { TotalRecord, rows } = response.data
                    if (TotalRecord <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar("查無資料", { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        enqueueSnackbar("Success", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        // console.log(rows)
                        setPersonItem(rows);
                    }
                })
        }
    }



    const getFullData = (BarCodeStr,PersonalId) => {
        // console.log("BarCodeStr:", BarCodeStr);
        // console.log("PersonalId:", PersonalId);
        // console.log("Token:", token);
        const reportLoadSeq = reportLoadSeqRef.current + 1;
        reportLoadSeqRef.current = reportLoadSeq;
        resetReportState();

        PF.instance({
            method: "post",
            url: PF.url2 + "/Minmax/GetFullData_Customer",
            data: Qs.stringify({ Action: "none", parameter: { BarCodeStr,PersonalId } }),
            headers: { Authorization: 'Bearer ' + token }
        })
            .then(function (response) {
                // alert("完成")
                if (reportLoadSeq !== reportLoadSeqRef.current) {
                    return;
                }

                const { TotalRecord, Profile, LabData, GaugeData } = response.data;
                if (TotalRecord > 0) {
                    const people = Profile[0]
                    // console.log(rows);
                    setProfile({
                        age: people.age,
                        PersonalId: people.PersonalId,
                        UserName: people.UserName,
                        sogi: people.sogi,
                        checkdate: people.checkdate,
                        chart: people.chart,
                        barcode: people.barcode,
                        sex: people.sex || ' 男',
                        birthday: people.birthday || '1900/01/01'
                    })
                    //解析圖片為JSON物件
                    let PicJson = JSON.parse(Profile[0]["pic"]);
                    // console.log(PicJson);

                    Object.keys(PicJson || {}).map(pic => {
                        if (PicJson[pic] !== null && PicJson[pic] !== "") {
                            setPicObj(prev => ({
                                ...prev,
                                [pic]: PicJson[pic]?.split(',') || []
                            }))
                        }
                    });
                    //Lab
                    let ContentJson = JSON.parse(LabData[0]["content"]) || [];
                    // console.log(PF.multiFilter(ContentJson, { Err: ['true'] }))
                    const labErrItems = ContentJson.filter(x => x.Err === 'true');
                    setArray02(labErrItems)
                    // setArray02(prev => prev.concat(PF.multiFilter(ContentJson, { Err: ['true'] })))
                    setArray02_2(labErrItems)

                    // console.log(ContentJson);

                    let ContentJson2 = JSON.parse(GaugeData[0]["content"]) || [];
                    // console.log(ContentJson);
                    // console.log(ContentJson2);
                    let ary03 = PF.multiFilter(ContentJson2, { CheckCategory: ['一般體格', '醫生問診'] });
                    if (ary03.length > 0) {
                        setitems(prev => [...prev, { id: '03', title: ' - 理學檢查', data: ary03, i18n: intl.formatMessage({ id: "理學檢查" }) }])

                        // { id: '03', title: ' - 理學檢查', data: Array03 }
                        setArray03(ary03)

                    }



                    const CategoryArray04 = [
                        { id2: "0401", title2: "尿液常規檢查" },
                        // { id2: "0401", title2: "尿液常規檢查" },
                        { id2: "0402", title2: "尿沉渣" },
                        { id2: "0403", title2: "血液檢查" },
                        { id2: "0404", title2: "生化檢查" },
                        { id2: "0405", title2: "腫瘤標記" },
                        { id2: "0406", title2: "甲狀腺檢查" },
                        { id2: "0407", title2: "血清免疫檢查" },
                        { id2: "0408", title2: "賀爾蒙檢查" },
                        { id2: "0409", title2: "基因檢查" },
                        { id2: "0410", title2: "功能醫學" },
                        { id2: "0411", title2: "肝炎檢查" },
                        { id2: "0412", title2: "糞便檢查" },
                        { id2: "0413", title2: "重金屬檢查" },
                        { id2: "0414", title2: "微生物檢查" },
                    ];
                    if (ContentJson.length > 0) {
                        CategoryArray04.map(item => {
                            let y = ContentJson.filter(x => x.CheckCategory === item.title2)
                            // console.log(item)
                            if (y.length > 0) {
                                setsubItems(prev => ({
                                    ...prev,
                                    ['04']: [...prev['04'], { id2: item.id2, title2: item.title2, i18n2: intl.formatMessage({ id: item.title2 }) }]
                                }))
                            }
                        })
                        let ary04 = PF.multiFilter(ContentJson, { CheckCategory: CategoryArray04.map(object => object.title2) })
                        setArray04(ary04)

                        if (ary04.length > 0) {
                            setitems(prev => [...prev, { id: '04', title: ' - 檢驗', data: ContentJson, i18n: intl.formatMessage({ id: "檢驗" }) }])
                        }
                    }

                    //Gauge


                    // setArray02_1(PF.multiFilter(ContentJson2, { Err: ['true'] }))
                    const gaugeErrItems = ContentJson2.filter(x => x.Err === 'true');
                    setArray02_1(gaugeErrItems)
                    setArray02([...gaugeErrItems, ...labErrItems])
                    // setArray02(prev => [...Array02, ...PF.multiFilter(ContentJson, { Err: ['true'] })])
                    // arr02 = [...arr02, ...PF.multiFilter(ContentJson, { Err: ['true'] })]

                    // let Array03 = PF.multiFilter(ContentJson, { CheckCategory: ['醫生問診'] });
                    // console.log(ContentJson);
                    // console.log(PF.multiFilter(ContentJson, { Err: ['true'] }))

                    let ItemArray = PF.multiFilter(ContentJson2, { CheckCategory: PicCategoryArray });
                    let ItemArray2 = PF.multiFilter(ContentJson, { CheckCategory: PicCategoryArray });
                    if (ItemArray2.length > 0) {
                        ItemArray = [...ItemArray, ...ItemArray2]
                    }
                    // console.log(ContentJson2);
                    // console.log(ItemArray);
                    // console.log(ItemArray2);
                    let object = _.keyBy(ItemArray, 'CheckCategory');
                    // console.log(ItemArray);
                    // console.log(object);
                    // console.log([...ContentJson2, ...ContentJson]);
                    let y = {}
                    Object.keys(object).map(CheckCategory => {
                        // y[CheckCategory] = PF.multiFilter([...ContentJson2, ...ContentJson], { CheckCategory: CheckCategory })
                        y[CheckCategory] = [...ContentJson2, ...ContentJson].filter(x => x.CheckCategory === CheckCategory)
                    })

                    // console.log(y);
                    setGaugeItem(y)
                    CategoryArray05.map((item, index) => {
                        if (y[item.title2]?.length > 0) {    //console.log(y[item.title2]);   看看 y[title2] 是否正確
                            setsubItems(prev => ({
                                ...prev,
                                ['05']: [...prev['05'], { id2: item.id2, title2: item.title2, i18n2: intl.formatMessage({ id: item.title2 }) }]
                            }))
                        }
                    })

                    if (Object.keys(y).length > 0) {
                        setitems(prev => [...prev, { id: '05', title: ' - 影像檢查', data: y, i18n: intl.formatMessage({ id: "影像檢查" }) }])
                        //console.log(y)   看看 y 物件的內容


                    }
                    //06 其他檢查
                    let array6 = PF.multiFilter(ContentJson2, { Category: ['其他檢查'] })
                    //希望的順序＆子頁碼
                    const CategoryArray06 = [
                        { id2: "0601", title2: "肺功能檢查", i18n2: intl.formatMessage({ id: "肺功能檢查" }) },
                        { id2: "0602", title2: "抹片檢查", i18n2: intl.formatMessage({ id: "抹片檢查" }) },
                        // { id2: "0603", title2: "功能醫學" },
                        { id2: "0604", title2: "分泌物檢查", i18n2: intl.formatMessage({ id: "分泌物檢查" }) },

                    ];
                    setArray06(array6)
                    if (array6.length > 0) {
                        setitems(prev => [...prev, { id: '06', title: ' - 其他檢查', data: array6, i18n: intl.formatMessage({ id: "其他檢查" }) }])
                        CategoryArray06.map(item => {
                            let y = array6.filter(x => x.CheckCategory === item.title2)
                            // console.log(item)
                            if (y.length > 0) {
                                setsubItems(prev => ({
                                    ...prev,
                                    ['06']: [...prev['06'], { id2: item.id2, title2: item.title2, i18n2: intl.formatMessage({ id: item.title2 }) }]
                                }))
                            }
                        })
                    }

                }
                else {
                }
            })
    }
    const isRowMaster = useMemo(() => {
        return (dataItem) => {
            return dataItem ? dataItem.Children.length > 0 : false;
        };
    }, []);
    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                columnDefs: [
                    // { field: 'barcode', headerName: "條碼號", width: 180 },
                    { field: 'FileName', headerName: "檔案名稱", minWidth: 150, width: 300 },
                ],
                defaultColDef: {
                    flex: 1,
                },

                rowSelection: 'single',
                onRowDoubleClicked: event => {
                    const { data } = event;
                    // console.log(data)
                    let s = _.replace(data.FullPathName, "\\\\192.168.25.20\\", "");
                    let t = s.replaceAll('\\', '/')
                    // console.log(t)
                    let str = "http://medirep.mornjoy.com.tw/Content/Upload/" + t
                    // console.log(str)
                    saveAs(str, data.FileName)

                }

            },
            getDetailRowData: (params) => {

                params.successCallback(params.data.Children);
            },
        };
    }, []);
    useEffect(() => {

        setitems(initialItems);
        setsubItems(initialsubItems)
        setColumnDefs(isMobile ? initialColumnDefsMobile : initialColumnDefs)
    }, [i18n.locale])
    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
        >

            <Grid item xs={12} sm={12} md={12} lg={12} style={{ height: '100%', width: '100%', minHeight: 400 }}>
                <Typography style={{ color: 'blue'}}>
                    {intl.formatMessage({ id:"●點擊 '(姓名)'兩下，即可下載該次 '(健檢報告)'"})}
                </Typography><br/>
                <Typography style={{ color: 'green' }}>
  {intl.formatMessage({
    id: "●若有其他相關附件，會於健檢日前方顯示"
  })}
  <span style={{
    color: 'red',
    fontWeight: 'bold',
    fontSize: '22px',
    margin: '0 5px'
  }}>
    &gt;
  </span>
  {intl.formatMessage({
    id: "符號，並可以展開（瀏覽中請按上一頁避免直接關閉）"
  })}
</Typography>
<br />
                <Typography style={{ color: 'blue' }}>{intl.formatMessage({ id:"●歷年比對報告線上瀏覽請點選≡  (僅供線上查看)"})}</Typography>
                <div className={dark ? "ag-theme-alpine-dark" : "ag-theme-alpine"} style={{ height: '100px', minHeight: 400 }}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={PersonItem}
                        columnDefs={columnDefs}
                        rowSelection='single'
                        defaultColDef={defaultColDef}
                        // rowMultiSelectWithClick={true}
                        onCellDoubleClicked={onRowDoubleClicked}
                        // enableCellTextSelection={true}
                        // ensureDomOrder={true}
                        // groupSelectsFiltered={true}
                        // suppressRowClickSelection={true}
                        enableRangeSelection={true}
                        style={{ height: '100%', minHeight: 400 }}
                        onFirstDataRendered={onFirstDataRendered}
                        masterDetail={true}
                        detailCellRendererParams={detailCellRendererParams}
                        isRowMaster={isRowMaster}


                    >
                    </AgGridReact>
                </div>
            </Grid>

            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
            >
                <DialogTitle style={{ backgroundColor: indigo[500], paddingBottom: 30 }}>

                    <IconButton style={{
                        position: 'absolute',
                        right: 5,
                        top: 5,

                    }}
                        onClick={handleClose}
                    >
                        <CloseIcon style={{ color: "white" }} />
                    </IconButton>
                </DialogTitle >
                <DialogContent dividers style={{ padding: 0 }}>
                    <Minmax Array02={Array02} items={items} Profile={Profile} Array03={Array03} Array04={Array04}
                        Array06={Array06} GaugeItem={GaugeItem} PicObj={PicObj} Array02_1={Array02_1} Array02_2={Array02_2} subItems={subItems} seturl={seturl} />
                </DialogContent>

            </Dialog>
        </Grid>
    )
}
const PersistentDrawerLeft = () => {
    const dispatch = useDispatch();

    const { dark, i18n } = useSelector(state => ({
        dark: state.app.dark,
        i18n: state.app.i18n,
    }));
    const [playActive] = useSound(
        switchlight,
        { volume: 0.5 }
    );
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    const navigate = useNavigate();
    const intl = useIntl();
    const handleLogout = () => {
        navigate(`/MinmaxLogin`, { replace: true });
        dispatch(actions.UserInfo({}));
        dispatch(actions.TOKEN_SET(""));
        // return redirect("/MinmaxLogin");
        // return <Navigate to="/MinmaxLogin" replace={true} />
    }
    const [anchorEl, setAnchorEl] = React.useState(null);
    const TranslateOpen = Boolean(anchorEl);
    const handleTranslateClose = () => {
        setAnchorEl(null);
    };
    const handleI18nChange = (event, lang) => {
        moment.locale(lang);
        dispatch(actions.LANG_SET(lang));
        setAnchorEl(null);
        playActive();
    };
    const [tabs, setTabs] = useState([]); // 開啟的 tab 列表
    const [activeTab, setActiveTab] = useState(null); // 當前 active tab

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar2 position="fixed" open={open}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        sx={{ mr: 2, ...(open && { display: 'none' }) }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap component="div">
                        {intl.formatMessage({ id: 'TitleName' })}
                    </Typography>
                </Toolbar>
            </AppBar2>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <DrawerHeader>
                    <Typography style={{ flex: 1, display: "flex", justifyContent: "center" }}>晨悅診所</Typography>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </DrawerHeader>
                <Divider />
                <List>

                    <ListItem key={1} disablePadding>
                        <ListItemButton onClick={() => dispatch(actions.THEME_SET({ theme: !dark }))}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                // e.stopPropagation();
                                playActive()
                            }}
                        >
                            <ListItemIcon>
                                <DarkModeSwitch
                                    // style={{ marginBottom: '2rem', float: "right" }}
                                    checked={dark}
                                    size={20} />
                            </ListItemIcon>
                            <ListItemText primary={!dark ? "Light" : "Dark"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key={2} disablePadding style={{ cursor: 'pointer' }}>
                        <ListItemButton onClick={e => { setAnchorEl(e.currentTarget); }}
                            onMouseDown={(e) => {
                                e.preventDefault();
                                // e.stopPropagation();
                                playActive()
                            }}
                        >
                            <ListItemIcon>
                                <GTranslate />
                            </ListItemIcon>
                            <ListItemText primary={i18n.locale === "zh-tw" ? "繁體中文" : "English"} />
                        </ListItemButton>
                    </ListItem>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={TranslateOpen}
                        onClose={handleTranslateClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        value={i18n.locale}

                    >
                        <MenuItem style={{ color: i18n.locale === "zh-tw" ? "white" : "", backgroundColor: i18n.locale === "zh-tw" ? teal[700] : "" }} selected={i18n.locale === "zh-tw"} value="zh-tw" onClick={(e) => handleI18nChange(e, "zh-tw")}>繁體中文</MenuItem>
                        <MenuItem style={{ color: i18n.locale === "en" ? "white" : "", backgroundColor: i18n.locale === "en" ? teal[700] : "" }} selected={i18n.locale === "en"} value="en" onClick={(e) => handleI18nChange(e, "en")}>English</MenuItem>
                    </Menu>
                     <ListItem key={3} disablePadding>
                                        <ListItemButton onClick={() => {
                                            const tabKey = 'AnnualReportCustomer';
                                            const existingTab = tabs.find(tab => tab.key === tabKey);
                    
                                            if (!existingTab) {
                                                setTabs([...tabs, {
                                                    key: tabKey,
                                                    title: i18n.locale === "zh-tw" ? "年度健檢數值" : "Annual Report",
                                                    component: <AnnualReportCustomer /> // 報告頁元件
                                                }]);
                                            }
                    
                                            setActiveTab(tabKey);
                                            playActive();
                                        }}>
                                            <ListItemIcon>
                                                <SlideshowIcon />
                                            </ListItemIcon>
                                            <ListItemText 
                                                primary={i18n.locale === "zh-tw" ? "年度健檢數值" : "Annual Report"} 
                                            />
                                        </ListItemButton>
                                    </ListItem>
                    <ListItem key={4} disablePadding>
                        <ListItemButton onClick={handleLogout}>
                            <ListItemIcon>
                                <ExitToAppIcon />
                            </ListItemIcon>
                            <ListItemText primary={intl.formatMessage({ id: "app.Logout" })} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </Drawer>
            <Main open={open}>
                        {/* Tabs 區塊 */}
                        {tabs.length > 0 && (
                            <>
                            <Box sx={{ mt: 3 }}> {/* 這裡讓 Tabs 整體往下移一點 */}
                                <Tabs
                                value={activeTab}
                                onChange={(e, newValue) => setActiveTab(newValue)}
                                variant="scrollable"
                                scrollButtons="auto"
                                sx={{
                                    borderBottom: 1,
                                    borderColor: "divider",
                                    minHeight: 30, // Tabs 區塊高度縮小
                                }}
                                >
                                {tabs.map((tab) => (
                                    <Tab
                                    key={tab.key}
                                    value={tab.key}
                                    label={
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                        {tab.title}
                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                            e.stopPropagation();
                                            setTabs(tabs.filter((t) => t.key !== tab.key));
                                            if (activeTab === tab.key) {
                                                const remaining = tabs.filter(
                                                (t) => t.key !== tab.key
                                                );
                                                setActiveTab(
                                                remaining.length > 0 ? remaining[0].key : null
                                                );
                                            }
                                            }}
                                        >
                                            ✕
                                        </IconButton>
                                        </Box>
                                    }
                                    sx={{ minHeight: 36 }} // 每個 Tab 高度也縮小
                                    />
                                ))}
                                </Tabs>
                            </Box>
            
                            {/* Tab 內容 */}
                            <Box sx={{ mt: 2 }}>
                                {tabs.map((tab) => (
                                <div
                                    key={tab.key}
                                    style={{ display: tab.key === activeTab ? "block" : "none" }}
                                >
                                    {tab.component}
                                </div>
                                ))}
                            </Box>
                            </>
                        )}
            
                        {/* 永遠保留 App，但當有 Tab 時隱藏 */}
                        <div style={{ display: tabs.length > 0 ? "none" : "block" }}>
                            <App  />
                        </div>
                     </Main>
        </Box >
    );
}
export default PersistentDrawerLeft;
